import HorizontalLayoutContainer from '../publicLayout/components/HorizontalLayoutContainer';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { H2 } from 'foundations-components/transitional/components/H2';
import { Flex } from 'foundations-components/components/Flex';
import { PublicCatalogResultsDisplay } from '../publicCatalog/components/PublicCatalogResults';
import { useGetPopularCoursesForHomepage } from './popularCoursesHooks';
import { getPublicLang } from 'academy-common-lib/utils/url';
import usageTracker from '../../utils/usageTracker';
import { ThemedPrimaryRouterButton } from '../../components/ThemedComponents';
import { View } from 'foundations-components/components/View';
import { useExperiment } from '../../../experiments/hooks';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import RouterLink from 'ui-addon-react-router-dom/RouterLink';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CoursesCategoryLinks = {
  MARKETING: 'marketing',
  SALES: 'sales',
  SERVICE: 'service',
  SOFTWARE: 'software'
};
const CategoryLink = ({
  category
}) => {
  return /*#__PURE__*/_jsx(RouterLink, {
    onClick: () => usageTracker.track('interaction', {
      action: 'popular-courses-category-link-click',
      value: category
    }),
    padding: "400",
    to: `/courses/${CoursesCategoryLinks[category]}`,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `academyPublic.homepage.popularCourses.${category}`
    })
  });
};
const PopularCoursesSection = () => {
  const {
    popularCoursesData,
    popularCoursesError,
    popularCoursesLoading
  } = useGetPopularCoursesForHomepage();
  const {
    treatment
  } = useExperiment('acad-0033');
  const currentLang = getPublicLang();
  const isExperimentActive = ['en', 'es'].includes(currentLang) && treatment === 'variation';
  const {
    isMobile
  } = useMediaQuery();
  const handleViewAllCoursesLinkClick = () => {
    usageTracker.track('interaction', {
      action: 'popular-courses-view-all-click'
    });
  };
  const getPadding = () => {
    if (isMobile) {
      return isExperimentActive ? '600' : '1200';
    }
    return isExperimentActive ? '800' : '1600';
  };
  return /*#__PURE__*/_jsx(View, {
    as: "section",
    backgroundColor: "do-not-use-gypsum",
    paddingBlockStart: getPadding(),
    children: /*#__PURE__*/_jsxs(HorizontalLayoutContainer, {
      children: [/*#__PURE__*/_jsx(H2, {
        marginBlockEnd: "800",
        textAlign: "center",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academyPublic.homepage.popularCourses.heading"
        })
      }), /*#__PURE__*/_jsx(Flex, {
        justifyContent: "center",
        marginBlockEnd: "1200",
        children: Object.keys(CoursesCategoryLinks).map(category => {
          return /*#__PURE__*/_jsx(CategoryLink, {
            category: category
          }, category);
        })
      }), /*#__PURE__*/_jsx(PublicCatalogResultsDisplay, {
        data: popularCoursesData,
        disablePaginator: true,
        disableSchema: true,
        error: popularCoursesError,
        language: getPublicLang(),
        loading: popularCoursesLoading
      }), /*#__PURE__*/_jsx(View, {
        textAlign: "center",
        children: /*#__PURE__*/_jsx(ThemedPrimaryRouterButton, {
          onClick: handleViewAllCoursesLinkClick,
          to: `/courses`,
          use: "primary",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "academyPublic.homepage.popularCourses.viewAll"
          })
        })
      })]
    })
  });
};
export default PopularCoursesSection;